import {Directive, OnInit, ElementRef, OnDestroy, Renderer2, HostListener, Input} from '@angular/core';
import { DecimalPipe } from '@angular/common';
import { NgControl } from '@angular/forms';
import { FocusMonitor } from '@angular/cdk/a11y';

import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { isNumber } from 'lodash';

/**
 * Override in the DOM the value of the input to be displayed formatted according the en-US locale
 *   `,` as thousand separator
 *   `.` as decimal separator
 */
@Directive({
  selector: '[thousands]',
})
export class ThousandDirective implements OnInit, OnDestroy {
  
  get inputValue() {
    return this._control ? this._control.value : null;
  }

  constructor(
    private _elementRef: ElementRef,
    private _control: NgControl,
    private _renderer: Renderer2,
    fm: FocusMonitor) {

    fm.monitor(_elementRef.nativeElement, true)
      .pipe(takeUntil(this.destroyed))
      .subscribe(origin => {
        const focused = !!origin;
      });
  }
  destroyed = new Subject();

  ngOnInit() {
    
  }

  @HostListener('input', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    const input = event.target as HTMLInputElement;
    
    let trimmed = input.value.replace(/\s+/g, '');
    const max = trimmed.length;
    let numbers = [];

    for(let i = 0; i < max ; i += 3) {
      let nb = trimmed.substring(i, i + 3);
      numbers.push(nb);
    }

    input.value = numbers.join(' ');

  }
  ngOnDestroy() {
    this.destroyed.next(true);
    this.destroyed.complete();
  }
}
